import { render, staticRenderFns } from "./buy_bom_new.vue?vue&type=template&id=01f5dfec&scoped=true"
import script from "./buy_bom_new.vue?vue&type=script&lang=js"
export * from "./buy_bom_new.vue?vue&type=script&lang=js"
import style0 from "./buy_bom_new.vue?vue&type=style&index=0&id=01f5dfec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f5dfec",
  null
  
)

export default component.exports